// A tablet, in either orientation.
//
// SAM-218 — deliberately NOT built on top of isMobileDevice() and NOT folded
// into it. isMobileDevice() answers a different question ("is this a small,
// one-handed screen") and on purpose says *no* to a tablet held in landscape;
// it also drives layout in ~20 other places, so widening it to catch modern
// iPads would move furniture all over the app. This predicate is for
// "is this a touch tablet", and nothing else reads it.
//
// The maxTouchPoints clause is load-bearing: since iPadOS 13, Safari on an
// iPad reports a desktop Macintosh user agent by default, so the /ipad/ regex
// alone misses most real iPads in the field.
export const isTabletDevice = () => {
  const ua = navigator.userAgent || "";
  if (/ipad|android(?!.*mobile)/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ masquerading as desktop Safari.
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
};

export const isMobileDevice = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isTablet = /ipad|android(?!.*mobile)/i.test(ua);
  const isPhone = /iphone|ipod|android.*mobile|iemobile|blackberry|bada/i.test(ua);

  const isLandscape = window.innerWidth > window.innerHeight;

  // Exclude tablets in landscape only
  if (isTablet && isLandscape) {
    return false;
  }

  return isPhone || isTablet;
};

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};
